import { FETCH_GET, FETCH_POST } from "../../config";
import { getProductsByCategory } from "./product";

export const SET_CATEGORY = "SET_CATEGORY";
export const FETCH_CATEGORY_PENDING = "FETCH_CATEGORY_PENDING";
export const FETCH_CATEGORY_FULFILLED = "FETCH_CATEGORY_FULFILLED";
export const FETCH_CATEGORY_REJECTED = "FETCH_CATEGORY_REJECTED";
export const FETCH_CATEGORY_BY_SLUG_PENDING = "FETCH_CATEGORY_BY_SLUG_PENDING";
export const FETCH_CATEGORY_BY_SLUG_FULFILLED =
  "FETCH_CATEGORY_BY_SLUG_FULFILLED";
export const FETCH_CATEGORY_BY_SLUG_REJECTED =
  "FETCH_CATEGORY_BY_SLUG_REJECTED";

export const setCategory = (category) => (dispatch) => {
  dispatch({ type: SET_CATEGORY, payload: category });
  dispatch(getProductsByCategory(category.id));
};

export const getCategoryBySlug = (slug) => {
  const query = `query($slug:String!){getCategoryBySlug(slug:$slug){id,title,order,slug,style{color,bg},discount{percent,price}}}`;
  const variables = JSON.stringify({ slug: slug });
  return async (dispatch) => {
    dispatch({ type: FETCH_CATEGORY_BY_SLUG_PENDING });
    try {
      const result = await FETCH_POST({ query: query, variables: variables });
      if (result.data.errors) {
        dispatch({
          type: FETCH_CATEGORY_BY_SLUG_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FETCH_CATEGORY_BY_SLUG_FULFILLED,
          payload: result.data.data.getCategoryBySlug,
        });
        dispatch(getProductsByCategory(result.data.data.getCategoryBySlug.id));
      }
    } catch (e) {
      dispatch({ type: FETCH_CATEGORY_BY_SLUG_REJECTED });
    }
  };
};

export const fetchCategory = () => {
  const query = `query={fetchCategories{id,title,order,slug,style{color,bg},discount{percent,price}}}`;
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_CATEGORY_PENDING });
    const data = getState().category.categories;
    if (data.length === 0) {
      try {
        const result = await FETCH_GET(query);
        if (result.data.errors) {
          dispatch({
            type: FETCH_CATEGORY_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: FETCH_CATEGORY_FULFILLED,
            payload: result.data.data.fetchCategories,
          });
        }
      } catch (e) {
        dispatch({ type: FETCH_CATEGORY_REJECTED });
      }
    }
  };
};

// export const getCategory = () => {
//   const query = `query={fetchCategories{id,title,order,slug}}`;
//   return async (dispatch, getState) => {
//     dispatch({ type: FETCH_CATEGORY_PENDING });
//     const data = getState().category.categories;
//     if (data.length === 0) {
//       try {
//         const result = await FETCH_GET(query);
//         if (result.data.errors) {
//           dispatch({
//             type: FETCH_CATEGORY_REJECTED,
//             payload: result.data.errors
//           });
//         } else {
//           dispatch({
//             type: FETCH_CATEGORY_FULFILLED,
//             payload: result.data.data.fetchCategories
//           });
//         }
//       } catch (e) {
//         dispatch({ type: FETCH_CATEGORY_REJECTED });
//       }
//     }
//   };
// };



// WEBPACK FOOTER //
// ./src/store/actions/category.js